module.exports = __webpack_public_path__ + "img/imag7.0cabf981.png";